import {
    OceTable,
    RecognitionArea,
    RecognitionAreaData,
    TableData,
    TableField,
    TableObjData,
} from "../util/interfaceData"

export function resetRecoAreaData(data: RecognitionArea) {
    let recognitionArea: Array<RecognitionAreaData> = []
    let errorData: Array<RecognitionAreaData> = []
    let multiField: Array<RecognitionAreaData> = []
    let multiErrorData: Array<RecognitionAreaData> = []
    for (let [key, value] of Object.entries(data)) {
        if (typeof value === "string" && value !== "") {
            recognitionArea.push({
                key: key,
                value: value,
            })
        } else if (typeof value === "object" && value !== {}) {
            for (let [multiFieldKey, multiFieldValue] of Object.entries(value)) {
                if (typeof multiFieldValue === "string" && multiFieldValue !== "") {
                    multiField.push({
                        key: `${key}-${multiFieldKey}`,
                        value: multiFieldValue,
                    })
                } else {
                    multiErrorData.push({
                        key: `${key}-${multiFieldKey}`,
                        value: multiFieldValue,
                    })
                }
            }
        } else {
            errorData.push({
                key: key,
                value: "",
            })
        }
    }
    multiField.forEach((item) => {
        recognitionArea.push(item)
    })
    multiErrorData.forEach((item) => {
        errorData.push(item)
    })
    return {
        recognitionArea: recognitionArea,
        errorField: errorData,
    }
}
export function resetOcrTableData(data: OceTable, tableField: Array<TableField>) {
    let tableData: Array<TableObjData> = []
    tableField.forEach((item: TableField) => {
        for (let key in data) {
            if (item.tableName === key) {
                let Data = {
                    tableHead: item.tableListName,
                    tableData: {
                        tablename: item.tableName,
                        data: data[key],
                    },
                }
                tableData.push(Data)
            }
        }
    })
    return tableData
}
